<template>
	<k-dialog v-model="dialog_open" scrollable persistent>
		<k-card id="k-rubric-dialog-card" style="display: flex; flex-direction: column; gap: 0px">
			<k-card-title class="k-rubric-dialog-title pb-2 pt-2" style="border-bottom:1px solid #ccc">
				<b><k-icon color="primary" class="mr-3">fas fa-ballot-check</k-icon>{{ title_text }}</b>
				<k-spacer/>
				<div v-if="!editing_on">
					<k-menu
						v-model="rubric_association_menu"
						:close-on-content-click="false"
						accessible-popover
						accessible-label="Rubric associations"
						content-id="rubric-associations-panel"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<k-btn 
								small 
								class="k-tight-btn" 
								v-bind="{
									...framework_color_bind_button,
									...attrs
								}"
								v-on="on"
							>
								<k-icon small class="mr-2">fas fa-arrows-alt-h</k-icon>
								View Rubric Associations
							</k-btn>
						</template>
						<k-card style="display: flex; flex-direction: column;  gap:16px; padding: 16px;">
							<h4>Rubric Associations</h4>
							<div v-if="rubric_association_items && rubric_association_items.length > 0" style="max-height: 300px; overflow-y: auto; display: flex; flex-direction: column; gap:8px;">
								<div v-for="item in rubric_association_items" class="d-flex align-start">
									<k-btn icon x-small color="#222" accessible-label="Show associated item" @click="() => show_aligned_item(item)"><k-icon>fas fa-arrows-left-right</k-icon></k-btn>
									<span @click="() => show_aligned_item(item)" class="ml-2" style="cursor:pointer" v-html="associated_item_uri_title(item)"></span>
									<k-btn class="ml-2 elevation-1" x-small fab v-bind="framework_color_bind_button" dark accessible-label="Open associated item" @click="() => show_aligned_item(item)"><k-icon small>fas fa-arrows-alt-h</k-icon></k-btn>
									<k-btn v-if="editing_on" class="ml-2 elevation-1" x-small fab color="red darken-2" dark accessible-label="Remove rubric association" @click="() => delete_rubric_association_by_item(item)"><k-icon small>fas fa-trash-alt</k-icon></k-btn>
								</div>
							</div>
							<div v-else style="font-size: 14px;">Rubric is not currently associated to any items.</div>
							<div v-if="editing_on">
								<k-btn small class="k-tight-btn" @click="show_aligned_item" v-bind="framework_color_bind_button">
									<k-icon small class="mr-2">fas fa-arrows-alt-h</k-icon>Associate Rubric to Item
								</k-btn>
							</div>
						</k-card>
					</k-menu>
					<k-menu :open-on-hover="false" :transition="false" bottom left accessible-popover accessible-label="Rubric options" content-id="rubric-options-panel"><template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" icon color="#222" class="ml-2" accessible-label="Open rubric options"><k-icon>fas fa-ellipsis-v</k-icon></k-btn></template>
						<k-list dense>
							<k-list-item v-if="editing_enabled" @click="start_editing"><k-list-item-icon><k-icon small>fas fa-edit fa-fw</k-icon></k-list-item-icon><k-list-item-title>Edit Rubric</k-list-item-title></k-list-item>
							<k-list-item @click="print_rubric"><k-list-item-icon><k-icon small>fas fa-print fa-fw</k-icon></k-list-item-icon><k-list-item-title>Print Rubric</k-list-item-title></k-list-item>
							<k-list-item @click="export_rubric"><k-list-item-icon><k-icon small>fas fa-file-export fa-fw</k-icon></k-list-item-icon><k-list-item-title>Export Rubric</k-list-item-title></k-list-item>
						</k-list>
					</k-menu>
					<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" x-small fab color="#222" dark accessible-label="Close rubric" @click="$emit('dialog_cancel')"><k-icon>fas fa-xmark</k-icon></k-btn></template>Close rubric</k-tooltip>
				</div>

				<div v-else>
					<k-menu
						v-model="rubric_association_menu"
						:close-on-content-click="false"
						accessible-popover
						accessible-label="Rubric associations"
						content-id="rubric-associations-panel"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<k-btn 
								small 
								class="k-tight-btn" 
								v-bind="{
									...framework_color_bind_button,
									...attrs
								}"
								v-on="on"
								:disabled="is_new_rubric"
							>
								<k-icon small class="mr-2">fas fa-arrows-alt-h</k-icon>
								View Rubric Associations
							</k-btn>
						</template>
						<k-card style="display: flex; flex-direction: column;  gap:16px; padding: 16px;">
							<h4>Rubric Associations</h4>
							<div v-if="rubric_association_items && rubric_association_items.length > 0" style="max-height: 300px; overflow-y: auto; display: flex; flex-direction: column; gap:8px;">
								<div v-for="item in rubric_association_items" class="d-flex align-start">
									<k-btn icon x-small color="#222" accessible-label="Show associated item" @click="() => show_aligned_item(item)"><k-icon>fas fa-arrows-left-right</k-icon></k-btn>
									<span @click="() => show_aligned_item(item)" class="ml-2" style="cursor:pointer" v-html="associated_item_uri_title(item)"></span>
									<k-btn class="ml-2 elevation-1" x-small fab v-bind="framework_color_bind_button" dark accessible-label="Open associated item" @click="() => show_aligned_item(item)"><k-icon small>fas fa-arrows-alt-h</k-icon></k-btn>
									<k-btn v-if="editing_on && can_remove_last_rubric_association" class="ml-2 elevation-1" x-small fab color="red darken-2" dark accessible-label="Remove rubric association" @click="() => delete_rubric_association_by_item(item)"><k-icon small>fas fa-trash-alt</k-icon></k-btn>
								</div>
							</div>
							<div v-else style="font-size: 14px;">Rubric is not currently associated to any items.</div>
							<div v-if="editing_on">
								<k-btn small class="k-tight-btn" @click="show_aligned_item" v-bind="framework_color_bind_button">
									<k-icon small class="mr-2">fas fa-arrows-alt-h</k-icon>Associate Rubric to Item
								</k-btn>
							</div>
						</k-card>
					</k-menu>
					<k-btn v-if="!is_new_rubric" small class="mr-1" color="red darken-3" dark @click="delete_rubric"><k-icon small class="mr-2">fas fa-trash-alt</k-icon>Delete Rubric</k-btn>
					<k-btn small class="mr-1" color="secondary" dark @click="import_rubric"><k-icon small class="mr-2">fas fa-file-import</k-icon>{{is_new_rubric?'Import Rubric':'Re-Import Rubric'}}</k-btn>
					<template v-if="isStateChanged">
						<k-btn class="mr-1" small color="#222" dark @click="cancel_editing"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
						<k-btn small @click="save_rubric" color="primary" :disabled="!title"><k-icon small class="mr-2">fas fa-save</k-icon>Save Changes</k-btn>
					</template>
					<template v-else-if="is_new_rubric">
						<k-btn small color="#222" dark @click="cancel_editing"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
					</template>
					<template v-else="is_new_rubric">
						<k-btn small @click="cancel_editing" color="primary"><k-icon small class="mr-2">fas fa-check</k-icon>Done Editing</k-btn>
					</template>
				</div>
			</k-card-title>
			<k-card-text class="k-rubric-dialog-content" :class="editing_on?'pr-1':'pr-0'">
				<!-- if editing, show form values -->
				<div v-if="editing_on" class="d-flex pt-2 pb-4" style="gap: 16px">
					<div style="flex:1;">
						<div class="k-case-ie-line-label k-rubric-editor-required">Rubric Title:</div>
						<k-text-field background-color="#fff" clearable outlined dense hide-details="auto" :rules="[rules.required]" v-model="title" />
					</div>
					<div style="flex:1">
						<div class="k-case-ie-line-label">Rubric Description:</div>
						<k-textarea background-color="#fff" outlined dense hide-details rows="1" v-model="description" auto-grow clearable />
					</div>
					<div style="flex:1">
						<div class="k-case-ie-line-label">Rubric Notes:</div>
						<k-textarea background-color="#fff" outlined dense hide-details rows="1" v-model="notes" auto-grow clearable />
					</div>
				</div>

				<!-- else show description and notes if present -->
				<div v-if="!editing_on&&!is_new_rubric" class="d-flex">
					<div v-if="rubric.description" class="mt-2 mx-2 pa-2" style="flex:0 1 50%; background-color:#eee; border-radius:6px;">
						<div><b>Rubric Description:</b></div>
						<div v-html="U.marked_latex(rubric.description)"></div>
					</div>
					<div v-if="rubric.notes" class="mt-2 mx-2 pa-2" style="flex:0 1 50%; background-color:#eee; border-radius:6px;">
						<div><b>Rubric Notes:</b></div>
						<div v-html="U.marked_latex(rubric.notes)"></div>
					</div>
				</div>

				<CFRubricGrid v-model="criteria" :rubric_identifier="rubric_identifier" :initial_rubric_component_identifier_showing="initial_rubric_component_identifier_showing" :framework_record="framework_record" :editing_on="editing_on" />
			</k-card-text>
		</k-card>
		<CFRubricImportModal 
			v-model="rubric_importer_is_open" 
			:rubric_identifier="rubric_identifier"
			:framework_record="framework_record" 
			:initiating_cfitem="initiating_cfitem"
			:existing_rubric="!is_new_rubric ? rubric : null"
			:existing_association="rubric_association"
		/>
		<CFRubricPrintModal 
			v-model="print_preview_is_open"
			:modal_context="this"
		/>
	</k-dialog>
</template>

<script>
import CFRubricGrid from './CFRubricGrid.vue'
import CFRubricImportModal from './CFRubricImportModal.vue'
import CFRubricPrintModal from './CFRubricPrintModal.vue'

const DEFAULT_NEW_RUBRIC_CRITERION_LEVEL_COUNT = 4
const DEFAULT_NEW_RUBRIC_CRITERION_LEVEL_QUALITIES = ['Minimally Proficient', 'Partially Proficient', 'Proficient', 'Highly Proficient']

export default {
	components: {CFRubricGrid, CFRubricImportModal, CFRubricPrintModal},
	props: {
		initiating_cfitem: { type: Object, required: false },
		rubric_identifier: { type: String, required: true },
		framework_record: { type: Object, required: true },
		initial_rubric_component_identifier_showing: { type: String, required:false, default() { return ''}},
		association_type: { type: String, required: false, default: 'ext:hasRubric' },
	},
	data() {return {
		dialog_open: true,
		editing_on: false,
		title: "",
		description: "",
		notes: "",
		criteria: [],
		initialState: {
			title: "",
			description: "",
			notes: "",
			criteria: [],
		},
		rules: {
			required: value => !!value || 'Field is required',
		},
		rubric_importer_is_open: false,
		rubric_association_menu: false,
		print_preview_is_open: false,
	}},
	computed: {
		// get rubric from rubric_entity_hash; if not there, it's a new rubric
		rubric() { return this.framework_record.cfo.rubric_entity_hash[this.rubric_identifier] },
		is_new_rubric() { return empty(this.rubric) },

		// the association tying the rubric (not criteria) to a CFItem. if this is a new rubric it won't yet exist, and it may not exist ever (rubrics shouldn't be required to be tied to cfitems)
		rubric_association() {
			if (this.is_new_rubric) return null
			// for now we make the simplifying assumption that a rubric can only be associated to a single cfitem
			const non_child_rubric_association = this.framework_record.json.CFAssociations.find(x=>x.associationType == 'ext:hasRubric' && x.destinationNodeURI.identifier == this.rubric_identifier)
			const child_rubric_association = this.framework_record.json.CFAssociations.find(x=>x.associationType == 'isChildOf' && x.originNodeURI.identifier == this.rubric_identifier)
			return child_rubric_association ?? non_child_rubric_association
		},

		// title for the dialog: either the rubric title if it's already created, or "New Rubric" otherwise
		title_text: function() { return this.is_new_rubric ? 'New Rubric (BETA)' : this.rubric.title },

		// reference to the currently-active CASEFrameworkViewer, if there is one (there probably always should be if we're showing a rubric)
		viewer() { return vapp.case_tree_component },
		editing_enabled() { return this.viewer?.editing_enabled },

		item_identifier() { return this.initiating_cfitem.identifier },

		isStateChanged() {
			return this.title !== this.initialState.title 
				|| this.description !== this.initialState.description
				|| this.notes !== this.initialState.notes
				|| JSON.stringify(this.criteria) !== JSON.stringify(this.initialState.criteria)
		},

		framework_color_bind_button() {
			const framework_color = U.framework_color(this.framework_record.lsdoc_identifier)
			if (!isNaN(framework_color)) {
				return {
					class: `k-framework-color-${framework_color}-dark`,
					style: {'color': 'white'}
				}

			} else {
				const framework_color_object = U.framework_color_object(this.framework_record.lsdoc_identifier)
				return { style: framework_color_object }  
			}
		},
		/**
		 *  Returns the CFAssociation objects that are associated with the rubric.
		 */
		rubric_associations() {
			const associations = this.get_associations_of_rubric_entity(this.rubric_identifier)
			return associations
		},
		/**
		 *  Returns the CFAssociation object that is the childOf association for the rubric.
		 */
		rubric_is_child_association() {
			return this.framework_record.json.CFAssociations.find(association => {
				const is_child_association = association.associationType == 'isChildOf'
				const origin_is_current_rubric = association.originNodeURI.identifier == this.rubric_identifier
				return is_child_association && origin_is_current_rubric
			})
		},
		/**
		 *  Returns true if the rubric is associated with a CFItem. If not, then
		 *  returns true if the rubric is association to more than one CFItem. Else
		 *  returns false.
		 */
		can_remove_last_rubric_association() {
			const rubric_is_child = this.rubric_is_child_association
			const rubric_has_enough_associations = this.rubric_associations.length > 1
			return rubric_is_child || rubric_has_enough_associations
		},
		/**
		 *  Returns the CFItem objects that are associated with the rubric. It does not
		 *  include the item the rubric is a child of.
		 */
		rubric_association_items() {
			const associations = this.rubric_associations

			if (!associations) return null
			const all_items = []
			associations.forEach(assoc => {
				const item = this.framework_record.json.CFItems.find(x=>x.identifier == assoc.originNodeURI.identifier)
				if (item) all_items.push(item)
			})

			if (all_items.length == 0) return null
			return all_items
		},

		associated_item_uri_title() { return (item) => {
			if (!item) return ''
			return U.generate_cfassociation_node_uri_title(item, 80, true)
		}},
	},
	mounted() {
		vapp.rubric_modal_component = this

		// Listen for rubric import completion
		this.$root.$on('rubric-imported', () => {
			// Force recomputation of rubric computed property
			this.$forceUpdate()
		})

		// if we already have a rubric for the incoming rubric_identifier, establish editable properties from it
		if (this.framework_record.cfo.rubric_entity_hash[this.rubric_identifier]) {
			this.title = this.rubric.title
			this.description = this.rubric.description
			this.notes = this.rubric.notes
			// note that we use an object_copy here
			this.criteria = object_copy(this.rubric.CFRubricCriteria)

		// else establish default properties for the new rubric
		} else {
			// note that the including component (currently CASEItemTile) should mint a new rubric_identifier for new rubrics
			this.title = 'New Rubric'
			this.description = ''
			this.notes = ''

			// establish a default criterion and levels
			let rc = new CFRubricCriterion()
			rc.position = 1
			rc.rubricId = this.rubric_identifier
			rc.weight = 1
			rc.complete_data(this.framework_record.json.CFDocument)	// this establishes the identifier and uri
			
			for (let i = 0; i < DEFAULT_NEW_RUBRIC_CRITERION_LEVEL_COUNT; i++) {
				let rcl = new CFRubricCriterionLevel()
				// use default qualities defined above; this could be made configurable from instance to instance
				rcl.quality = DEFAULT_NEW_RUBRIC_CRITERION_LEVEL_QUALITIES[i]
				rcl.score = i + 1
				rcl.position = i + 1
				rcl.rubricCriterionId = rc.identifier
				rcl.complete_data(this.framework_record.json.CFDocument)	// this establishes the identifier and uri
				rc.CFRubricCriterionLevels.push(rcl)
			}

			// use the json version for consistency with what we do when this is an existing rubric
			this.criteria = [rc.to_json()]

			// we must be in editing mode if it's a new rubric
			this.editing_on = true
		}

		this.set_initial_state()
	},
	methods: {
		set_initial_state() {
			this.initialState = {
				title: this.title,
				description: this.description,
				notes: this.notes,
				criteria: JSON.parse(JSON.stringify(this.criteria))
			}
		},

		start_editing() {
			this.editing_on = true
		},

		/**
		 *  Takes the identifier of an entity within the rubric and returns its associations.
		 *  These entities can be the rubric itself, a criterion, or a criterion level.
		 *  Does not include the isChildOf association for the rubric.
		 * 
		 * 	@param {string} identifier the identifier of the rubric entity
		 *  @returns {CFAssociation[]|null} the associations of the rubric entity, or null if none exist
		 */
		get_associations_of_rubric_entity(identifier) {
			let associations = this.framework_record.cfo.associations_hash[identifier]
			if (!associations) return null
			associations.forEach(x => {
				if (!U.is_rubric_association(x)) {
					console.warn('something fishy: this should be a rubric association ', x)
					return null
				}
			})
			return associations
		},

		async show_aligned_item(focused_item = null) {
			let data = {
				framework_identifier: this.framework_record.lsdoc_identifier
			}

			let rubric_entity_identifier = this.rubric.identifier
			let existing_associations = this.framework_record.cfo.associations_hash[rubric_entity_identifier]

			if (existing_associations && existing_associations.length > 0) {
				data.selected_items = existing_associations.map(x=>x.originNodeURI.identifier)
			}

			if (focused_item) {
				data.item_identifier = [focused_item.identifier]
			}

			let show_data = { 
				// fn called when embedded satchel is hidden; here we don't need to do anything special when that happens
				// embed_hide_callback_fn: ()=>{ this.aligning_to_standards = false },

				// fn called continuously while embedded satchel is open; if it returns true, embedded satchel will be closed. 
				// use this to close embedded satchel if the user leaves the rubric editor altogether, or switches to editing a different row or cell
				hide_fn: ()=>{ 
					if ($(vapp.rubric_grid_component?.$el).is(':visible') == false) return true
					return false
				},
			}

			await vapp.$refs.satchel.execute('show', show_data)
			await vapp.$refs.satchel.execute('load_framework', data)
			
			if (!this.editing_on) return 
			const aligned_item = await vapp.$refs.satchel.execute('chooser', {chooser_mode: true})

			const is_aligned_item_a_rubric = aligned_item.cfitem.uri.includes('/CFRubrics/')

			if (is_aligned_item_a_rubric) {
				vapp.$refs.satchel.execute('hide')
				this.$alert({
					title: 'Invalid Selection',
					text: 'You cannot make an association to another rubric.',
					acceptText: 'OK',
				})
				return
			}

			let payload =  {
				lsdoc_identifier: this.framework_record.lsdoc_identifier,
				CFAssociations: []
			}

			const existing_association = existing_associations ? existing_associations.find(x=>x.originNodeURI.identifier == aligned_item.cfitem.identifier) : null
			if (existing_association) {
				this.delete_rubric_association_by_item(aligned_item.cfitem)
				
			} else {
				let new_association = new CFAssociation({
					"originNodeURI": {
						"title": U.generate_cfassociation_node_uri_title(aligned_item.cfitem),
						"identifier": aligned_item.cfitem.identifier,
						"uri": aligned_item.cfitem.uri
					},
					"associationType": 'ext:hasRubric',
					"destinationNodeURI": {
						"title": this.title.substring(0, 20),
						"identifier": this.rubric.identifier,
						"uri": this.rubric.uri
					}
				})
				new_association.complete_data(this.framework_record.json.CFDocument)	// this establishes the identifier and uri
				payload.CFAssociations.push(new_association.to_json())
			}

			await this.$store.dispatch('save_framework_data', payload)

			for (let assoc of payload.CFAssociations) {
				if (assoc.delete != 'yes') {
					assoc.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
					await this.$store.commit('set', [this.framework_record.json.CFAssociations, 'PUSH', assoc])
					U.update_associations_hash(this.framework_record.cfo, assoc)
					this.viewer.update_association_display({framework_id: this.framework_record.lsdoc_identifier, assoc: assoc, actions: ['add', 'display']})
				}
			}

			this.$forceUpdate()
			this.show_aligned_item()	// this will execute when the standards are hidden
		},

		cancel_editing() {
			// if the rubric was never saved, close the dialog; else turn editing off
			if (this.is_new_rubric) this.$emit('dialog_cancel')
			else this.editing_on = false
		},

		save_rubric() {
			// create rubric object

			// trim all descriptions and other text-based inputs before saving
			for (let rc of this.criteria) {
				rc.description = $.trim(rc.description)
				rc.notes = $.trim(rc.notes)
				for (let rcl of rc.CFRubricCriterionLevels) {
					rcl.description = $.trim(rcl.description)
					rcl.quality = $.trim(rcl.quality)
					rcl.feedback = $.trim(rcl.feedback)
				}
			}

			let rubric = new CFRubric({
				identifier: this.rubric_identifier,
				title: $.trim(this.title),
				description: $.trim(this.description),
				notes: $.trim(this.notes),
				CFRubricCriteria: this.criteria
			})

			// complete the rubric, filling in uri and lastChangeDateTime -- lastChangeDateTime will be set to *NOW*, whether this is a new rubric or an existing rubric we're updating, which is what we want
			rubric.complete_data(this.framework_record.json.CFDocument)

			// start constructing the payload for save_framework_data
			let payload = { lsdoc_identifier: this.framework_record.lsdoc_identifier }

			let association = null

			if (this.is_new_rubric) {
				payload.CFRubrics = [rubric.to_json()]

				const associated_rubric = {
					title: this.title,
					identifier: rubric.identifier,
					uri: rubric.uri
				}

				const associated_item = {
					title: U.generate_cfassociation_node_uri_title(this.initiating_cfitem),
					identifier: this.initiating_cfitem.identifier,
					uri: this.initiating_cfitem.uri
				}
				
				association = new CFAssociation({
					destinationNodeURI: this.association_type == 'ext:hasRubric' ? associated_rubric : associated_item,
					associationType: this.association_type,
					originNodeURI: this.association_type == 'ext:hasRubric' ?  associated_item : associated_rubric,
				})

				if (this.association_type == 'isChildOf') {
					association.sequenceNumber = U.get_next_sequenceNumber(this.initiating_cfitem.tree_nodes[0], this.framework_record)
				}

				// complete the association, filling in identifier, uri and lastChangeDateTime; then add to payload
				association.complete_data(this.framework_record.json.CFDocument)
				payload.CFAssociations = [association.to_json()]

			} else {
				// for updating an existing rubric, we don't need to change the association
				payload.CFRubrics = [rubric.to_json_for_update()]
			}

			this.$store.dispatch('save_framework_data', payload).then(response => {
				// once the save_framework_data service completes successfully, we need to update the framework's data model in the $store

				// update timestamps with the value sent back from the server, then update or push to store...
				// for now at least (12/5/2024), the server will update the dates of both the rubric and all criteria and levels on every save
				rubric.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
				for (let rc of rubric.CFRubricCriteria) {
					rc.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
					for (let rcl of rc.CFRubricCriterionLevels) {
						rcl.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
					}
				}

				// get new rubric json
				let rubric_json = rubric.to_json()

				// whether the rubric was new or updated, add/update the rubric an all its sub-entities in rubric_entity_hash. (it's important to do this before the other changes below, but as soon as we do this, is_new_rubric will change...)
				let is_new_rubric = this.is_new_rubric
				U.update_rubric_entity_hash(rubric_json, this.framework_record)

				if (is_new_rubric) {
					// push rubric json to store
					this.$store.commit('set', [this.framework_record.json.CFRubrics, 'PUSH', rubric_json])

					// push association json to store if we saved one
					if (association) {
						association.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
						let assoc_json = association.to_json()
						this.$store.commit('set', [this.framework_record.json.CFAssociations, 'PUSH', assoc_json])
						/*
						update cfo.associations_hash unless it's a childOf association.
						When the cfo is built it does not include childOf associations in the hash,
						so we want to follow that pattern here.
						*/
						if (this.association_type != 'isChildOf') {
							U.update_associations_hash(this.framework_record.cfo, assoc_json)
							this.viewer.update_association_display({framework_id: this.framework_record.lsdoc_identifier, assoc: assoc_json, actions: ['add', 'display']})
						}
						
					}
					// add a new item to the cfo (we'll take it back out if needed); put the sequenceNumber we will save the item to in node.sequence, for use in ItemEditor.save_changes
					// note: since sequenceNumber is guaranteed to be higher than the last index of the parent's children array, the item will always get spliced to the end of children
					if (this.association_type == 'isChildOf') {
						U.add_child_to_cfo(rubric_json, this.initiating_cfitem.tree_nodes[0], this.$store, this.framework_record.cfo)
					}
					
				} else {
					// splice updated rubric json to store
					let i = this.framework_record.json.CFRubrics.findIndex(x=>x.identifier == rubric.identifier)
					this.$store.commit('set', [this.framework_record.json.CFRubrics, 'SPLICE', i, rubric.to_json()])
				}

				// reset the initial state
				this.set_initial_state()                
			})
		},

		tabber(event) {
			U.tabber(event)
		},

		/**
		 *  Deletes the rubric and all its associations. This includes the rubric itself,
		 *  all criteria, all levels, and the associations for each part.
		 */
		async delete_rubric() {
			try {
				const confirmed = await this.$confirm({
					title: 'Are you sure?',
					text: 'Are you sure you want to delete this Rubric?',
					acceptText: 'Delete',
					acceptColor: 'red darken-2',
				})
				if (confirmed) {
					const payload = {
						lsdoc_identifier: this.framework_record.lsdoc_identifier,
						CFRubrics: [{
							identifier: this.rubric_identifier,
							delete: 'yes',
						}],
					}

					await this.$store.dispatch('save_framework_data', payload)
					await U.async_delete_from_rubric_entity_hash(this.rubric, this.framework_record) // TODO rename this function without word "test"
					await this.delete_all_rubric_associations()
					
					const rubric_index = this.framework_record.json.CFRubrics.findIndex(x => x.identifier == this.rubric_identifier)
					if (rubric_index > -1) {
						await this.$store.commit('set', [this.framework_record.json.CFRubrics, 'SPLICE', rubric_index])
						this.viewer.build_cfo()
					}

					this.$emit('dialog_cancel')
				} else {
					console.log('Rubric deletion cancelled by user.')
				}
			} catch (error) {
				console.error('Error during rubric deletion process:', error)
			}
		},
		/**
		 *  Deletes the CFAssociation between the rubric and the item. Will not work
		 *  with criteria or levels.
		 * 
		 * 	@param {CFItem} item
		 */
		delete_rubric_association_by_item(item) {
			const association_to_delete = this.rubric_associations.find(association => {
				/** 
				Since we only check against the originNodeURI, we don't need to
				worry about removing 'isChildOf' associations since the item is 
				the destinationNodeURI in that case.
				*/
				return association.originNodeURI.identifier == item.identifier
			})
			this.delete_associations([association_to_delete])
		},
		/**
		 *  Recursively deletes all CFAssociations associated with the rubric. This includes
		 * 	the rubric itself, all criteria, and all levels.
		 */
		async delete_all_rubric_associations() {
			let associations_to_delete = this.rubric_associations || []

			if (!!this.rubric_is_child_association) {
				associations_to_delete.push(this.rubric_is_child_association)
			}

			this.criteria.forEach(criterion => {
				const criterion_associations = this.get_associations_of_rubric_entity(criterion.identifier) || []
				console.log('associations_to_delete 3', criterion_associations)
				associations_to_delete.push(...criterion_associations)

				criterion.CFRubricCriterionLevels.forEach(level => {
					const level_associations = this.get_associations_of_rubric_entity(level.identifier) || []
					console.log('associations_to_delete 4', level_associations)
					associations_to_delete.push(...level_associations)
				})
			})
			associations_to_delete = [...new Set(associations_to_delete.map(x => x.identifier))].map(id => {
				return associations_to_delete.find(x => x.identifier == id)
			})
			try {
				await this.delete_associations(associations_to_delete)
			} catch (error) {
				console.error('Error deleting associations:', error)
			}
			
		},
		/**
		 * @param {CFAssociation[]} associations_to_delete
		 */
		async delete_associations(associations_to_delete) {
			const payload = {
				framework_record: this.framework_record,
				associations_to_delete: associations_to_delete
			}

			try {
				await this.$store.dispatch('delete_associations', payload)
			}
			catch (error) {
				console.error('Error deleting associations:', error)
			}
		},
		print_rubric() {
			this.print_preview_is_open = true
		},
		
		export_rubric() {
			this.$alert('This functionality is coming soon...')
		},

		import_rubric() {
			this.rubric_importer_is_open = true
		},

	},
	watch: {
		rubric: {
			handler(newRubric) {
				if (newRubric) {
					this.title = newRubric.title
					this.description = newRubric.description
					this.notes = newRubric.notes
					this.criteria = object_copy(newRubric.CFRubricCriteria)
					this.set_initial_state()
				}
			},
			deep: true
		},
	},
}
</script>

<style scoped lang="scss">

#k-rubric-dialog-card {
	background-color: white !important;
	font-size:16px;
	line-height:21px;

	.k-rubric-dialog-title {
		.k-editor-title {
			width: 100%;
		}
	}

	.k-rubric-dialog-content {
		font-size:15px;
		line-height:20px;
		.spacer {
			height: 32px;
			width: 100%;
		}
	}
}
.k-rubric-editor-required::after {
	content: "*";
	color: red;
}
</style>
